const overflowStyle = {
  '.overFlowPopUpVisible': {
    position: 'absolute',
    marginTop: '10px',
    zIndex: 9999,
    boxShadow: '5px 7px 12px 0px rgba(0,0,0,0.18)', // shadow on right and bottom, full box
    borderRadius: '6px',
    background: '#fff',
  },
  '.overFlowPopUpHidden': {
    display: 'none',
    position: 'absolute',
  },
};

export default overflowStyle;
